import { render, staticRenderFns } from "./AsociarEventosForm2.vue?vue&type=template&id=42f99058&scoped=true&"
import script from "./AsociarEventosForm2.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosForm2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosForm2.vue?vue&type=style&index=0&id=42f99058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f99058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42f99058', component.options)
    } else {
      api.reload('42f99058', component.options)
    }
    module.hot.accept("./AsociarEventosForm2.vue?vue&type=template&id=42f99058&scoped=true&", function () {
      api.rerender('42f99058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarEventosForm2.vue"
export default component.exports